















































































import { Component, Vue, Watch } from "vue-property-decorator";
import GlobalMixins from "../mixins";
import OptionsHeader from "@/components/OptionsHeader.vue";
import { StemWijzerHTTP } from "@/main";
import qs from "qs";

@Component({
  components: {
    OptionsHeader,
  },
})
export default class SelectAnalytics extends GlobalMixins {
  sendAllChoices: boolean = false;
  sendForAnalysis: boolean = false;

  get statementsForAnalytics(): {
    statementID: number;
    position: -1 | 0 | 1 | -2;
  }[] {
    return this.statements.map((statement) => {
      let position: -1 | 0 | 1 | -2 = -2;

      this.user.choices.forEach((item) => {
        if (item.originalStatementId === statement.id) {
          switch (item.choice) {
            case "disagree":
              position = -1;
              break;
            case "neither":
              position = 0;
              break;
            case "agree":
              position = 1;
              break;
            case "skip":
            default:
              position = -2;
              break;
          }
        }
      });

      return {
        statementID: statement.id,
        position,
      };
    });
  }
  get stats() {
    return {
      votematchID: this.config.settings.analytics.votematchID,
      themes: this.themesForAnalytics(true),
      statements: this.statementsForAnalytics,
      elapsed: this.$store.getters.timeSpendMakingChoices * 100,
      token: this.$store.state.user.analyticsToken,
      version: this.config.settings.analytics.version
        ? this.config.settings.analytics.version
        : -1,
    };
  }
  get store() {
    const parties = this.results(false).map((result) => {
      return {
        partyID: result.party.id,
        percentage: result.percentage,
        selected:
          (this.user.selectedParties as number[]).indexOf(result.party.id) !==
          -1
            ? 1
            : 0,
      };
    });

    return {
      vmid: this.config.settings.analytics.votematchID,
      data: JSON.stringify({
        statements: this.statementsForAnalytics,
        themes: this.themesForAnalytics(false),
        parties,
        votematchID: this.config.settings.analytics.votematchID,
        version: this.config.settings.analytics.version,
        templateVersion: this.config.settings.analytics.templateVersion,
        timeSpendMakingChoices: this.$store.getters.timeSpendMakingChoices,
        firstStatementDefaultIndex:
          this.$store.getters.firstStatementDefaultIndex,
      }),
    };
  }

  @Watch("sendAllChoices")
  onSendAllChoicesChange() {
    this.setUserAnalytics();
  }
  @Watch("sendForAnalysis")
  onSendForAnalysisChange() {
    this.setUserAnalytics();
  }

  themesForAnalytics(compact: boolean) {
    return this.statements.map((statement) => {
      let weight = 0;

      if (this.user.priorityStatements && this.user.priorityStatements.length) {
        if (this.user.priorityStatements.indexOf(statement.id) !== -1)
          weight = 1;
      }

      if (compact) {
        return {
          statementID: statement.id,
          themeID: statement.themeId,
          weight,
        };
      } else {
        return {
          statementID: statement.id,
          themeID: statement.themeId,
          theme: statement.theme,
          weight,
        };
      }
    });
  }
  next() {
    this.trackGAEvent("results");

    this.$store.dispatch("seenAnalyticsQuestion");

    this.$router.push({ name: "results" }).then(() => {
      this.sendUserAnalytics();
    });
  }
  setUserAnalytics() {
    this.$store.dispatch("setUserAnalytics", {
      sendAllChoices: this.sendAllChoices,
      sendForAnalysis: this.sendForAnalysis,
    });
  }
  sendUserAnalytics() {
    if (this.sendAllChoices) {
      if (process.env.NODE_ENV === "production") {
        setTimeout(() => {
          StemWijzerHTTP.post(
            this.config.settings.analytics.statsUrl,
            qs.stringify(this.stats)
          );
        }, 4000);
      } else {
        console.info("Running on dev, not sending stats.");
        console.log(this.stats);
      }
    }
    if (this.sendForAnalysis) {
      if (process.env.NODE_ENV === "production") {
        setTimeout(() => {
          StemWijzerHTTP.post(
            this.config.settings.analytics.storeUrl,
            qs.stringify(this.store)
          );
        }, 5000);
      } else if (this.sendForAnalysis) {
        console.info("Running on dev, not sending store.");
        console.log(this.store);
      }
    }
  }
  created() {
    this.sendAllChoices = this.user.analytics.sendAllChoices;
    this.sendForAnalysis = this.user.analytics.sendForAnalysis;
  }
}
